import React, {useEffect,useState} from 'react'
import {Col, Container, Row, Button, Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Stepper from './stepper';
import CallImage from './ico-call.png'
import loaderImg from '../images/loader.svg'

// see: https://stackoverflow.com/a/60909422/11748942
// switch's reference: https://codepen.io/tutsplus/pen/BaVyNaw

export const Step6 = ({result, resultMonthOptm, resultMonthPesm, resultYearOptm, resultYearPesm, values ,nextStep}) => {
  const { t } = useTranslation("global");

  // Show/Hide modals
  const [PolicyCoverageModalShow, setPolicyCoverageModalShow] = useState(false);
  const handlePolicyCoverageModalClose = () => setPolicyCoverageModalShow(false);
  const handlePolicyCoverageModalShow = () => setPolicyCoverageModalShow(true);
  const [VehicleCoverageModalShow, setVehicleCoverageModalShow] = useState(false);
  const handleVehicleCoverageModalClose = () => setVehicleCoverageModalShow(false);
  const handleVehicleCoverageModalShow = () => setVehicleCoverageModalShow(true);

  useEffect(() => {
    // default option selected on switch
    var monthly = document.querySelector('label[for=results-switch-monthly]');
    monthly.classList.add("selected");
  });
  const handleSwitchChange = input => e => {
    //this.setState({ [input]: e.target.value });
    // console.log(e.target.value);
    var monthly = document.querySelector('label[for=results-switch-monthly]');
    var yearly = document.querySelector('label[for=results-switch-yearly]');
    if (e.target.value === 'monthly') {
      monthly.classList.add("selected"); 
      yearly.classList.remove("selected");
    } else {
      monthly.classList.remove("selected"); 
      yearly.classList.add("selected"); 
    }
    updateContent(e.target.value)
  }

  const updateContent = (mode) => {
    var monthlyRange = document.querySelector('.monthly-range');
    var yearlyRange = document.querySelector('.yearly-range');
    if (mode === 'monthly') {
      monthlyRange.classList.remove("hidden");
      yearlyRange.classList.add("hidden");
    } else {
      monthlyRange.classList.add("hidden");
      yearlyRange.classList.remove("hidden");
    }
  }

  return (
    <Container style={{marginTop:"2%"}}>
      <Row>
        <Col lg={3}></Col>
        <Col lg={7}>
          <div className="page-texts result-page-texts">
            <p className="title">{t("step6.page.title")}</p>
            <p className="subtitle">{t("step6.page.subtitle")}</p>
          </div>
        </Col>
      </Row>

      <Row style={{marginTop:"1rem"}}>
        <Col lg={3}>
          <Stepper step="5" t={t}></Stepper>
        </Col>
        <Col lg={7}>

          <div className="results-box">
            <div className="results-switch-box">
              <Row>
                <Col lg={4}></Col>
                <Col lg={4}>
                  <div className="step6-switch-box" onChange={handleSwitchChange("switch")} key="inline-radio">
                    <Form.Check inline type="radio" name="1" label={t("step6.results.switch.monthly")} value="monthly" id="results-switch-monthly"/>
                    <Form.Check inline type="radio" name="1" label={t("step6.results.switch.yearly")} value="yearly" id="results-switch-yearly"/>
                  </div>
                </Col>
                <Col lg={4}></Col>
              </Row>
            </div>
            <div className="results-estimation-box">
              <Row>
                <Col lg={2}></Col>
                <Col lg={8}>
                  <p className="title">{t("step6.results.estimation.title")}</p>
                  {!resultMonthOptm ? (
                    <div className='flex justify-center'>
                      <img src={loaderImg} height="40px" alt="Call Icon"/>
                    </div>
                  ) : (
                    <div>
                      <p className="range monthly-range">${resultMonthOptm.toLocaleString("en")} - ${resultMonthPesm.toLocaleString("en")} {t("step6.results.estimation.range.monthly")}</p>
                      <p className="range yearly-range hidden">${resultYearOptm.toLocaleString("en")} - ${resultYearPesm.toLocaleString("en")} {t("step6.results.estimation.range.yearly")}</p>
                    </div>
                  )}
                </Col>
                <Col lg={2}></Col>
              </Row>
            </div>
            <div className="results-call-box">
              <Row>
                <Col lg={2}></Col>
                <Col lg={5} style={{display:"flex", textAlign:"left", alignItems:'center'}}>
                  <img src={CallImage} height="40px" alt="Call Icon"/>
                  <p className="text">{t("step6.results.call.text")}</p>
                </Col>
                <Col lg={3} style={{display:'flex', alignItems:'center'}}>
                  <Button variant="success" style={{width:"100%",fontSize:"0.8rem"}}>{t("step6.results.call.number")}</Button>
                </Col>
                <Col lg={2}></Col>
              </Row>
            </div>
            <div className="results-composition-box">
              <Row>
                <Col lg={2}></Col>
                <Col lg={8}>
                  <p className="title">{t("step6.results.composition.title")}</p>
                  <div className="policyCoverage-box">
                    <p className="subtitle">
                      <i className="fa-solid fa-file-lines"></i> {t("step6.results.composition.policyCoverage")} &nbsp;
                      <span className="question-modal" onClick={handlePolicyCoverageModalShow}><i className="fa-regular fa-circle-question"></i></span>
                    </p>
                    <p className="detail">
                      {t("step6.results.composition.policyCoverage.bodilyInjury")}....................${values.bodilyInjury}
                    </p>
                    <p className="detail">
                      {t("step6.results.composition.policyCoverage.propertyDamage")}..................${values.propertyDamage}
                    </p>
                    <Modal show={PolicyCoverageModalShow} onHide={handlePolicyCoverageModalClose}>
                      <Modal.Header closeButton>
                        <Modal.Title>{t("step6.results.composition.policyCoverage")}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body style={{whiteSpace:"pre-wrap"}}>{t("modal.liabilityLimits")}</Modal.Body>
                      <Modal.Footer>
                        <Button variant="success" onClick={handlePolicyCoverageModalClose}>{t("modal.close")}</Button>
                      </Modal.Footer>
                    </Modal>
                  </div>
                  <div className="vehicleCoverage-box">
                    <p className="subtitle">
                      <i className="fa-solid fa-car"></i> {t("step6.results.composition.vehicleCoverage")} &nbsp;
                      <span className="question-modal" onClick={handleVehicleCoverageModalShow}><i className="fa-regular fa-circle-question"></i></span>
                    </p>
                    <p className="detail">{t("step6.results.composition.policyCoverage.collision")}....................$500</p>
                    <p className="detail">{t("step6.results.composition.policyCoverage.comprehensive")}.............$500</p>
                    <Modal show={VehicleCoverageModalShow} onHide={handleVehicleCoverageModalClose}>
                      <Modal.Header closeButton>
                        <Modal.Title>{t("step6.results.composition.vehicleCoverage")}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body style={{whiteSpace:"pre-wrap"}}>{t("modal.vehicleCoverage")}</Modal.Body>
                      <Modal.Footer>
                        <Button variant="success" onClick={handleVehicleCoverageModalClose}>{t("modal.close")}</Button>
                      </Modal.Footer>
                    </Modal>
                  </div>
                </Col>
                <Col lg={2}></Col>
              </Row>
            </div>
            <div className="results-call-box">
              <Row>
                <Col>
                 {t("step6.results.disclaimer")}
                </Col>
              </Row>
            </div>
          </div>

        </Col>
      </Row>
    </Container>
  )
}

export default Step6;